import thunk from "redux-thunk";
import throttle from "lodash/throttle";
import { applyMiddleware, createStore } from "redux";
import appStore, { getPersistedState } from "./reducers";
import { loadState, saveState } from "./utilities/stateFunctions";

const persistedState = loadState();

const configureStore = () => {
    const middlewares = [ thunk ];
    if (process.env.NODE_ENV === 'development') {
        const { logger } = require(`redux-logger`);
        middlewares.push(logger);
    }

    const store = createStore(appStore, persistedState, applyMiddleware(...middlewares));
    store.subscribe(throttle(() => saveState(getPersistedState(store.getState())), 1000));
    return store;
};

export default configureStore;
